"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelationAffinityMode = void 0;
var RelationAffinityMode;
(function (RelationAffinityMode) {
    /**
     * For strong affinity mode on a relation attribute, deleting or creating the parent or the relation linkage will trigger a CASCADE delete or create to the relation entity itself.
     * For weak affinity mode on a relation attribute, deleting or creating the parent or the relation linkage will NOT trigger a CASCADE delete or create to the relation entity itself.
     */
    RelationAffinityMode["WEAK"] = "weak";
    RelationAffinityMode["STRONG"] = "strong";
})(RelationAffinityMode = exports.RelationAffinityMode || (exports.RelationAffinityMode = {}));
//# sourceMappingURL=schema-model.js.map